module.exports = __webpack_public_path__ + "img/1_hillstate.f9588af9.png";